'use client'

import { ReactNode } from 'react'
import { ErrorBoundary } from 'react-error-boundary'
import { getCustIdFromLS } from '@/utils/useUserInfo'

interface ErrorBoundaryProviderProps {
  children: ReactNode
}

function ErrorFallback({ error, resetErrorBoundary }: { error: Error; resetErrorBoundary: () => void }) {
  let customerId = ''
  try {
    customerId = getCustIdFromLS()
  } catch (e) {
    // Handle localStorage access error
  }
  
  return (
    <div 
      role="alert" 
      style={{ 
        padding: '2rem', 
        textAlign: 'center', 
        border: '1px solid #f44336', 
        borderRadius: '8px',
        backgroundColor: '#ffebee',
        margin: '2rem'
      }}
    >
      <h2 style={{ color: '#d32f2f', marginBottom: '1rem' }}>⚠️ Something went wrong!</h2>
      
      {customerId && customerId !== 'null' && customerId !== 'undefined' && (
        <p style={{ marginBottom: '1rem' }}>
          <strong>Customer ID:</strong> {customerId}
        </p>
      )}
      
      <pre style={{ 
        color: 'red', 
        backgroundColor: '#fff', 
        padding: '1rem', 
        borderRadius: '4px',
        margin: '1rem 0',
        fontSize: '14px',
        textAlign: 'left',
        overflow: 'auto'
      }}>
        {error.message}
      </pre>
      
      <button
        onClick={resetErrorBoundary}
        style={{
          padding: '0.5rem 1rem',
          backgroundColor: '#1976d2',
          color: 'white',
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer',
          fontSize: '16px'
        }}
      >
        Try again
      </button>
      
      <div style={{ marginTop: '1rem', fontSize: '14px', color: '#666' }}>
        <p>✅ App Router Error Boundary is working</p>
      </div>
    </div>
  )
}

const logError = (error: Error, info: { componentStack: string }) => {
  // Log error to console or external service
  console.error('App Router Error Boundary caught an error:', error)
  console.error('Component stack:', info.componentStack)
}

export default function ErrorBoundaryProvider({ children }: ErrorBoundaryProviderProps) {
  return (
    <ErrorBoundary
      FallbackComponent={ErrorFallback}
      onError={logError}
    >
      <div data-provider="error-boundary">
        {children}
      </div>
    </ErrorBoundary>
  )
}